module.exports = __webpack_public_path__ + "img/blue-shapes-with-logo.016fe670.svg";